export default __webpack_public_path__ + "static/media/pp-bg.a28ade50.png";